import * as React from 'react';
import { NaviContext } from './NaviContext';
export function useCurrentRoute() {
    var _a = React.useContext(NaviContext), steadyRoute = _a.steadyRoute, busyRoute = _a.busyRoute;
    return (steadyRoute || busyRoute);
}
//# sourceMappingURL=CurrentRoute.js.map